import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { QrReader } from "react-qr-reader";

/**
 * Render a expandable QR code
 *
 * IMPORTANT: For some reason hot reloading it's not working for changes in this component
 *
 */
const QRCodeReader = ({
  open,
  closeOnRead,
  hide,
  onRead,
  data,
  info,
  form,
  onSave,
  title,
  submitButton,
  showFooter,
  withManualInput = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={open} onHide={hide}>
      <Modal.Header closeButton>
        <h2 className="fw-bold mb-0">{title || t("general.scan")}</h2>
      </Modal.Header>

      <Modal.Body className="d-flex flex-column align-items-center justify-content-start position-relative">
        {((closeOnRead && !data) || !closeOnRead) && (
          <div style={{ width: 350, height: 350 }}>
            <QrReader
              constraints={{ facingMode: { ideal: "environment" } }}
              videoContainerStyle={{
                position: "inherit",
              }}
              videoStyle={{
                height: "100%",
                maxHeight: 350,
                margin: "auto"
              }}
              onResult={(data) => {
                if (!!data) {
                  const result = { ...data };
                  try {
                    onRead(result.text);
                  } catch (error) {
                    console.log(error);
                  }
                }
              }}
              onError={(error) => {
                console.log(error);
              }}
            />
          </div>
        )}

        {withManualInput && !data && (
          <TextInput
            label={t("views.checkin.form.userId")}
            onChange={(e) => {
              const id = e?.target?.value?.trim() || "";
              if (id.length === 8) {
                onRead(id);
              }
            }}
          />
        )}

        <div className="w-75 pt-2">
          {info}
          {!!data && form}
        </div>
      </Modal.Body>
      {(!!data || showFooter) && (
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="secondary" onClick={hide}>
            {t("general.cancel")}
          </Button>
          {submitButton || (
            <Button
              variant="primary"
              onClick={() => {
                onSave(data);
                hide();
              }}
            >
              {t("general.save").toUpperCase()}
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};

QRCodeReader.propTypes = {
  /** Prop that controls wheter the modal it's beign rendenr or not */
  open: PropTypes.bool.isRequired,
  /** Function called to close the modal */
  hide: PropTypes.func.isRequired,
  /** Function called when a QR code it's read */
  onRead: PropTypes.func.isRequired,
  /** Value previously readed */
  data: PropTypes.any,
  /** Render any extra info that you want with this prop */
  info: PropTypes.any,
  /** Function called to save previously read value */
  onSave: PropTypes.func.isRequired,
};

export default QRCodeReader;

const TextInput = ({ label, onChange }) => (
  <Form.Group
    className="d-flex flex-column mt-5 w-75"
    controlId="unique_id_input"
  >
    <Form.Label>{label}</Form.Label>
    <Form.Control type="text" autoComplete="off" onChange={onChange} />
  </Form.Group>
);
